export const maquetaTpl = {
  modalDatos: {
    regTitle: `تفاصيل التسجيل`,
    paymentMethod: `طريقة الدفع`,
    paymentDate: `تاريخ الدفع`,
    guestCount: `عدد الضيوف`,
    unspecified: `غير محدد`,
    pay: {
      DESTI: `الدفع عند الوصول`,
      EFECT: `نقدًا`,
      MOVIL: `الدفع عبر الجوال`,
      OTRO: `طرق دفع أخرى`,
      PLATF: `منصة الدفع`,
      TARJT: `بطاقة ائتمان`,
      TRANS: `تحويل بنكي`,
      TREG: `بطاقة هدايا`,
    },
  },
  whatsapp: {
    title: `وصول حصري إلى واتساب بزنس`,
    body: `للوصول إلى ميزة واتساب بزنس، يلزم اشتراك نشط في واتساب بزنس. صُمّم هذا الخيار ليمنحك أدوات إضافية وميزات متقدمة لتعزيز تجربتك التجارية.`,
  },
  nav: {
    welcome: `مرحبًا`,
    manager: `مدير`,
    logout: `تسجيل الخروج`,
    logoutError: `عذرًا، حدث خطأ أثناء تسجيل الخروج`,
  },
  subnav: {
    home: `الرئيسية`,
    clients: `العملاء`,
    prices: `الأسعار`,
    payments: `المدفوعات`,
    userManagement: `إدارة المستخدمين`,
  },
};
